import { observable } from "mobx";
import RoadType from "./roadType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RoadsSimpleListResponse {
  /**
   * Payment template ID.
   */
  id!: string;

  /**
   * Payment template code.
   */
  @observable
  name!: string;

  /**
   * Flag indicating if payment template is deleted.
   */
  @observable
  isDeleted!: boolean;

  /**
   * RoadType.
   */
  @observable
  roadType!: RoadType;
}
